.profileForm {
	@apply yst-space-y-6;
}
